module.exports = __webpack_public_path__ + "static/media/assyrian_text_04.72f5be19.jpg";